

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import request from 'sync-request';
import SessionExpiredComponent from './sessionExpired.js';

var config = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
}

const executeAxios = function (url, methodType, data, callBack) {
    triggerAxios(url, methodType, data, callBack)
}

const triggerAxios = function (url, methodType, data, callBack) {
    var uniqueToken = localStorage.getItem("uniqueToken");
    if (uniqueToken) {
        var headers = config.headers
        headers["uniqueToken"] = uniqueToken
    }
    if (methodType === "GET") {
        axios.get(url, config)
            .then(res => {
                return res.data
            }).then(res => {
                checkIfSessionExpiredOrNot(res, (status) => { callBack(res); });
            }).catch((ex) => {
                console.log('parsing failed', ex);
                callBack({});
            })
    } else if (methodType === "POST") {
        axios.post(url, data, config)
            .then(res => {
                return res.data
            }).then(res => {
                checkIfSessionExpiredOrNot(res, (status) => { callBack(res); });
            }).catch((ex) => {
                console.log('parsing failed', ex);
                callBack({});
            })
    }
}

const checkIfSessionExpiredOrNot = function (receivedResponse, callback) {
    if (receivedResponse.STATUS === "SESSION_EXPIRED") {
        executeImmediateLogout();
        //callback(true);
    } else {
        callback(true);
    }
}

const executeImmediateLogout = function () {
    ReactDOM.render(<SessionExpiredComponent />, document.getElementById('sessionOutDiv'));
}

const executeSyncRequest = function (methodType, url, dataToSend) {  //this is synchronus call
    var response = request(methodType, url, {
        'headers': {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        'json': dataToSend
    });
    return response;
}

export default {
    executeAxios, executeSyncRequest
}

